import React from 'react'

const DeliveryTime = () => {
  return (
    <div>DeliveryTime</div>
  )
}

export default DeliveryTime